import axios from 'axios'
// import store from '@/store'
import NProgress from 'nprogress'
import { Message } from 'element-ui'
// const baseURL = process.env.VUE_APP_BASE_URL + '/mock/56'
// const baseURL = process.env.VUE_APP_BASE_URL + '/mock/74'
const baseURL = process.env.VUE_APP_BASE_URL_API1
NProgress.configure({ showSpinner: false })
const request = axios.create({
  baseURL: baseURL,
  timeout: 90000,
  headers: {
    // 'Content-Type': 'application/json',
    // 'Accept': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    
    let ua = navigator.userAgent.toLowerCase();
    // 在微信浏览器和app环境下隐藏进度条
    if (ua.match(/MicroMessenger/i) != "micromessenger" && ua.indexOf('gkztc') == -1 ) {
      NProgress.start()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截器
request.interceptors.response.use(
  response => {
    NProgress.done()
    // console.log(response.data.code)
    if (response.data.code == 0) {
      return response.data
    } else {
      Message.error({
        message: response.data.msg
      })
      return response.data
    }
    
  },
  error => {
    Message.error({
      message: error.message
    })
    NProgress.done()
    return Promise.reject(error)
  }
)
export default request
